export const REPORT_CONFIG = {
    requests: {
        getReportStock: {
            url: `reports/4-stock-report`,
        },
        getReportPlanProduction: {
            url: `reports/1-production-plan-report`,
        },
        getReportPlanReview: {
            url: `reports/6-production-plan-review-report`,
        },
        getReportPlanSale: {
            url: `reports/5-sale-report`,
        },
        getReportPlanSale2: {
            url: `reports/2-sale-plan-report`,
        },
        getReportDistribution: {
            url: `reports/3-distribution-plan-report`,
        },
        getReportFuelCost: {
            url: `reports/8-fuel-cost-report`,
        },
        getReportDelivery: {
            url: `reports/7-delivery-cost-report`,
        },
        getReportInspection: {
            url: `reports/9-inspection-report`,
        },
        getDelivery10Report: {
            url: `reports/10-delivery-report`,
        },
        getDialySaleReport: {
            url: `reports/11-sale-daily-report`,
        },
        getSaleAgentReport: {
            url: `reports/12-sale-agent-report`,
        },
        getIncomeReport: {
            url: `reports/13-income-report`,
        },
        getSaleByLocationReport: {
            url: `reports/14-sale-by-location-report`,
        },
        getTransferReport: {
            url: `reports/15-transfer-report`,
        },
        getCustomerReport: {
            url: `reports/16-customer-report`,
        },
        getAgentReport: {
            url: `reports/17-agent-report`,
        },
        getReceiveReport: {
            url: `reports/18-receive-report`,
        },
        getSalePromotionReport: {
            url: `reports/19-sale-promotion-report`,
        },
        getRawSeedMovementReport: {
            url: `reports/phase2/01-raw-seed-movement-report`
        },
        getReceiptReport: {
            url: `reports/phase2/02-receipt-report`
        },
        getSeedProduceCostReport: {
            url: `reports/phase2/03-seed-produce-cost-report`
        },
        getDiscardSeedMovementReport: {
            url: `reports/phase2/04-discard-seed-movement-report`
        },
        getMaterialMovementReport: {
            url: `reports/phase2/05-material-movement-report`
        },
        getSeedProduceCostByItemReport: {
            url: `reports/phase2/06-seed-produce-cost-by-item`
        },
        lotMovementReport: {
            url: `reports/CR-20250908/lot-movement`
        },
        daysInStockReport: {
            url: `reports/CR-20250908/days-in-stock`
        },
        riceSeedReserveReport: {
            url: `reports/CR-20260602/rice-seed-reserve`
        },
        materialProductionReport: {
            url: `reports/CR-20260602/material-production`
        },
    }

};
